<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              @click:prepend="showFilter = !showFilter"
              @input="searchTerm"
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->
                          
               <v-btn color="success" @click="export2excel()" dark>
                <v-icon left>save</v-icon> export .xls
              </v-btn>                
            </v-toolbar>
            <v-divider/> 
            <v-card-text v-if="showFilter">              
              <v-layout row wrap>                                
                <v-flex md6 xs12>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" class="mr-3" multiple dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle> 

                </v-flex>                
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pa-0 tabular" id="journal">
              <v-data-table                
                :headers="complex.headers"                
                :items="complex.items"
                :loading="complex.loading"
                :pagination.sync="complex.options"
                :rows-per-page-items="[{text:'All','value':-1}]"   
                hide-actions             
                >
                <template slot="items" slot-scope="props">
                  <td>{{ ((complex.pagination.currentPage-1)*20)+(props.index+1) }}</td>                                   
                  <td>{{ props.item.nama }} ({{props.item.gender===1?'L':'P'}})</td>
                  <td>{{ props.item.telepon }}</td>                    
                  <td>
                    <template v-if="tingkats.length > 0">
                    {{ tingkats.find(x=>x.id===props.item.jurusan_id) ? tingkats.find(x=>x.id===props.item.jurusan_id).description : tingkats.find(x=>x.id===props.item.tingkat_id).description}}
                    </template>
                  </td>
                  <td>{{ props.item.ayah_nama }}</td>
                  <td>{{ props.item.ibu_nama }}</td>
                  <td>
                    <template v-if="status.length > 0 && props.item.payment" >
                    {{ status.find(x=>x.id===props.item.payment.status) ? status.find(x=>x.id===props.item.payment.status).name : null }}
                    </template>
                  </td>
                  <td>
                    <template v-if="Array.isArray(payments) && props.item.payment">
                    {{ payments.find(x=>x.id===props.item.payment.reff_type) ? payments.find(x=>x.id===props.item.payment.reff_type).name : null }}
                    </template>
                  </td>
                  <td>
                    <template v-if="props.item.payment">
                    {{props.item.payment.reff_number}}
                    </template>
                  </td>
                  <td>{{$moment(props.item.payment.updated_at*1000).format('DD-MMMYY (HH:mm)')}}</td>                  
                </template>
              </v-data-table>
              <v-divider/>
              <div class="text-xs-center pa-2">
                <v-pagination
                  v-model="complex.pagination.currentPage"
                  :length="complex.pagination.pageCount"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();
import Table2Excel from 'table2excel.js';  

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/signup/calon/payment/form',
        viewPath : '/signup/calon/payment/view',
        search   : '',
        loading  : true,
        toggle_tingkat : [],
        toggle_gender : [],
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              //{ text: 'ID',   value: 'id'  },
              { text: 'Nama', value: 'nama'},              
              { text: 'Telepon', value: 'telepon'}, 
              { text: 'Tingkat', value: 'tingkat_id'},
              { text: 'Nama Ayah', value: 'ayah_nama'},
              { text: 'Nama Ibu', value: 'ibu_nama'},
              { text: 'Status', value:'payment.status'},
              { text: 'Type', value:'payment.type'},
              { text: 'Reff', value:'payment.reff_number'},
              { text: 'Updated', value:'payment.updated_at'},
              //{ text: 'Action', value: '', align:'center' },              
            ],
            items: [],
            loading : false,
            options : {},
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            }
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        showFilter : true,
        payments:[],
    }),  
    watch:{
       toggle_tingkat(newArr){
        let tingkat = [], jurusan = [];
        newArr.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });                
        this.init(this.complex.pagination.currentPage, this.toggle_gender, tingkat, jurusan);        
      },
      toggle_gender(newArr){                
        this.init(this.complex.pagination.currentPage, newArr, this.filter.tingkat, this.filter.jurusan);        
      },
      'complex.pagination.currentPage'(newPage){        
        this.init(newPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      },
      'complex.options':{
        handler(){          
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)
        }, deep:true      
      },     
    },
    computed:{
      filter(){
        let tingkat = [], jurusan = [];
        this.toggle_tingkat.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        return {tingkat: tingkat, jurusan:jurusan};
      }
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});
      model.paymentStatus().then(data=>{this.status = data});
      model.paymentTypes().then(data=>{this.types = data});
      model.settings({key:'payment_method'}).then(res=>{
        this.payments = res.value;
      });
      this.init(); 
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
        },
        
        searchTerm:debounce(function (newText) {         
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)                         
        }, 500),

        init(page = 1, gender='', tingkat='', jurusan_id=''){
          this.complex.loading = true
          let  sortby = this.complex.options.sortBy ? this.complex.options.sortDesc ? 
            '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

          const params = {
            perPage: 20,
            page: page,
            expand:'payment',
            'UserCalonSearch[nama]': this.search,
            'UserCalonSearch[gender]': gender,
            'UserCalonSearch[tingkat_id]': tingkat,
            'UserCalonSearch[jurusan_id]': jurusan_id,
            sort:sortby,            
            nopagination:true  
          }
          this.complex.items = [];
          model.indexPayment(params).then(res => {      
              this.complex.items = res.data; 
              //this.complex.pagination.pageCount = res.pagination.pageCount;  
              this.complex.loading = false;
          });                                         
        },                
        
        export2excel(){
            if(this.complex.items.length !== 0){
                var filename = 'Payment.';            
                filename    += this.$moment().format('DDMMYY.HHmm');
                new Table2Excel('#journal table').export(filename);
            } else {
                window.getApp.$emit('showSnackbar', {
                    show : true,
                    text : 'No Data Result',
                    color: 'orange'
                });
            }
        },
    }
}
</script>
<style>
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 7px 0 15px
}
</style>            